import Vue from 'vue'
import axios from 'axios'
import router from '@/router'

export const Api = axios.create({
    baseURL: '',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
})

// Add JWT token and base URL for mobile app
Api.interceptors.request.use(function (config) {
    if (window.IS_MOBILE_APP) {
        const userAgent = navigator.userAgent
        let baseUrl = null
        switch (true) {
            case userAgent.includes('AgentApp'):
                baseUrl = 'https://api.housejet.com/'
                break;
            case userAgent.includes('SalesApp'):
                baseUrl = 'https://sapi.housejet.com/'
                break;
            default:
                baseUrl = 'https://api.housejet.com/'
        }
        config.baseURL = baseUrl
        const token = localStorage.getItem('jwt_token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

Api.interceptors.response.use(function (response) {
    return response
}, function ({response, message}) {
    if (!response) {
        return Promise.reject({status: 500, data: {message}})
    }

    // Handle 401 on mobile app — token expired or invalid
    if (window.IS_MOBILE_APP && response.status === 401) {
        localStorage.removeItem('jwt_token')
        router.push('/login')
        return new Promise(() => {}) // Prevent further error handling during redirect
    }

    return Promise.reject({status: response.status, data : response.data.message})
})
Vue.prototype.$http = Api
